var map = {
	"./bookmark-blue.svg": 632,
	"./buildings-blue.svg": 633,
	"./buildings-gray.svg": 634,
	"./checkbox.svg": 635,
	"./cloud-inactive.svg": 40,
	"./cloud.svg": 636,
	"./document.svg": 637,
	"./edit-inactive.svg": 28,
	"./edit.svg": 638,
	"./info.svg": 285,
	"./no-print.svg": 286,
	"./opcje.svg": 210,
	"./question.svg": 284,
	"./settings.svg": 287,
	"./standard.svg": 293,
	"./student-blue.svg": 639,
	"./student-gray.svg": 640,
	"./table.svg": 641,
	"./text-field.svg": 642,
	"./vector.svg": 294
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 631;